import cn from 'classnames';
import { FC, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@/shared/ui';

import styles from './MFAEnrollmentActions.module.scss';

type MFAEnrollmentActionsProps = {
  cancelLabel: ReactNode;
  isStarting: boolean;
  isConfirming: boolean;
  isCodeComplete: boolean;
  className?: string;
  onCancel: () => void;
  onConfirm: () => void;
};

/**
 * The cancel/confirm pair is shared so the enabled and loading rules of the
 * enrolment step stay identical in the card and in the modal, which differ
 * only in the chrome around them.
 */
export const MFAEnrollmentActions: FC<MFAEnrollmentActionsProps> = (props) => {
  const {
    cancelLabel,
    isStarting,
    isConfirming,
    isCodeComplete,
    className,
    onCancel,
    onConfirm,
  } = props;

  return (
    <div className={cn(styles.container, className)}>
      <Button
        className={styles.secondaryAction}
        variant="tertiary"
        disabled={isConfirming}
        onClick={onCancel}
      >
        {cancelLabel}
      </Button>

      <Button
        className={styles.primaryAction}
        loading={isConfirming}
        disabled={!isCodeComplete || isStarting}
        onClick={onConfirm}
      >
        <FormattedMessage id="global.confirm" defaultMessage="Confirm" />
      </Button>
    </div>
  );
};
